/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * ArrangeLayersIcon
 */
export default class ArrangeLayersIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M20.772 15a1 1 0 01.992 1.008 2 2 0 01-.964 1.696l-.142.078-6.87 3.435a4 4 0 01-3.363.099l-.214-.099-6.87-3.435a2 2 0 01-1.105-1.766 1 1 0 011.992-.14l.008.117 6.87 3.435a2 2 0 001.617.076l.171-.076 6.87-3.436A1 1 0 0120.772 15zm0-4a1 1 0 01.992 1.008 2 2 0 01-.964 1.696l-.142.078-6.87 3.435a4 4 0 01-3.363.099l-.214-.099-6.87-3.435a2 2 0 01-1.105-1.766 1 1 0 011.992-.14l.008.117 6.87 3.435a2 2 0 001.617.076l.171-.076 6.87-3.436A1 1 0 0120.772 11zm-10.56-8.224a4 4 0 013.577 0l6.87 3.435a2 2 0 010 3.578l-6.87 3.435a4 4 0 01-3.578 0l-6.87-3.435a2 2 0 010-3.578zm2.682 1.79a2 2 0 00-1.788 0L4.236 8l6.87 3.435a2 2 0 001.788 0L19.764 8z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

